export default __webpack_public_path__ + "static/media/testimonialConfirm.ec59ac2d.svg";